<template>
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1.66699L12.575 6.88366L18.3334 7.72533L14.1667 11.7837L15.15 17.517L10 14.8087L4.85002 17.517L5.83335 11.7837L1.66669 7.72533L7.42502 6.88366L10 1.66699Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "StarIcon"
};
</script>
